var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTeaching = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "School-Board-Maths--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "School Board Maths Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23 14.5H1a1 1 0 0 0 -1 1v0.5a1.49 1.49 0 0 0 1.13 1.45 0.5 0.5 0 0 1 0.37 0.49V23a1 1 0 0 0 2 0v-0.75a0.5 0.5 0 0 1 0.5 -0.5h16a0.5 0.5 0 0 1 0.5 0.5V23a1 1 0 0 0 2 0v-5.06a0.5 0.5 0 0 1 0.37 -0.49A1.49 1.49 0 0 0 24 16v-0.5a1 1 0 0 0 -1 -1Zm-2.5 4.75a0.5 0.5 0 0 1 -0.5 0.5H4a0.5 0.5 0 0 1 -0.5 -0.5V18a0.5 0.5 0 0 1 0.5 -0.5h16a0.5 0.5 0 0 1 0.5 0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 13h19a0.5 0.5 0 0 0 0.5 -0.5v-11A1.5 1.5 0 0 0 20.5 0h-17A1.5 1.5 0 0 0 2 1.5v11a0.5 0.5 0 0 0 0.5 0.5Zm14.6 -7.82a0.26 0.26 0 0 0 -0.28 0.06l-0.29 0.29a0.75 0.75 0 1 1 -1.06 -1.06l1.32 -1.32a1.35 1.35 0 0 1 1 -0.4 1 1 0 0 1 1 1v4.5a0.5 0.5 0 0 0 0.5 0.5H20a0.75 0.75 0 0 1 0 1.5h-4a0.75 0.75 0 0 1 0 -1.5h0.75a0.5 0.5 0 0 0 0.5 -0.5V5.41a0.25 0.25 0 0 0 -0.15 -0.23Zm-6.1 0.57h0.25a0.5 0.5 0 0 0 0.5 -0.5V5a0.75 0.75 0 0 1 1.5 0v0.25a0.5 0.5 0 0 0 0.5 0.5H14a0.75 0.75 0 0 1 0 1.5h-0.25a0.5 0.5 0 0 0 -0.5 0.5V8a0.75 0.75 0 0 1 -1.5 0v-0.25a0.5 0.5 0 0 0 -0.5 -0.5H11a0.75 0.75 0 0 1 0 -1.5Zm-4.5 -1.5A1.25 1.25 0 0 0 5.25 5.5a0.75 0.75 0 0 1 -1.5 0 2.75 2.75 0 1 1 4.4 2.2l-0.8 0.6a0.25 0.25 0 0 0 -0.09 0.28 0.26 0.26 0 0 0 0.24 0.17h1a0.75 0.75 0 0 1 0 1.5h-4a0.75 0.75 0 0 1 -0.45 -1.35l3.2 -2.4a1.23 1.23 0 0 0 0.5 -1A1.25 1.25 0 0 0 6.5 4.25Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTeaching);
export default ForwardRef;